"use strict";
//https://bo.wix.com/wix-docs/client/viewer-platform---ooi/articles/component#viewer-platform---ooi_articles_component_props
Object.defineProperty(exports, "__esModule", { value: true });
var ViewMode;
(function (ViewMode) {
    ViewMode["EDITOR"] = "Editor";
    ViewMode["PREVIEW"] = "Preview";
    ViewMode["SITE"] = "Site";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
//Desktop,Mobile,Tablet
var FormFactor;
(function (FormFactor) {
    FormFactor["MOBILE"] = "Mobile";
    FormFactor["DESKTOP"] = "Desktop";
    FormFactor["TABLET"] = "Tablet";
})(FormFactor = exports.FormFactor || (exports.FormFactor = {}));
//# sourceMappingURL=types.js.map